export default __webpack_public_path__ + "static/mineral-fest-2018-61d6f1593482f8bc790f6dd361c116fd.pdf";